import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './AudienceSeatingLayoutsEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import { MainCatalogTypes, MainCatalogs_Classes,  } from "../../_loadingHelpers/MainCatalogTypes";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import { FilelistAudienceSeating } from "../MainCatalogEditorTools";

class AudienceSeatingLayoutsEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    //input_Room: SearchSelect = new SearchSelect();
    input_Code: MdsLax<InstanceType<typeof Edit>>;
    input_Description: MdsLax<InstanceType<typeof Edit>>;
    input_Note: MdsLax<InstanceType<typeof Edit>>;
    input_SeatingCapacity: MdsLax<InstanceType<typeof NumberInput>>;
    checkbox_Default: MdsLax<InstanceType<typeof CheckBox>>;

    private filesEnabled: boolean = false;
    private expanderFilelist: MdsLax<InstanceType<typeof ExpandableSection>>;
    private filelist: MdsLax<InstanceType<typeof FilelistAudienceSeating>>;
    private filesSection: HTMLElement;

    formData: MainCatalogTypes.AudienceSeatingLayoutsEditor_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        note: "",
        seating_capacity: null,
        is_default: null,
        ev_room_id: "",
        is_to_delete: false,
        ref_ev_room__gDisp_1: "",
        ref_ev_room__ID: "",
        existingFiles: [],
        newFiles: [],
        deletedFiles: []
    };

    prepareFormData(data?: MainCatalogTypes.AudienceSeatingLayoutsEditor_LoadData): void {

        let evRoomId: string = null;

        if (data) {

            //this.input_Room._loadListValues();/*data.ref_ev_room?.ID, true*/
            evRoomId = data.ref_ev_room__ID

            this.input_Code.setValue(data.code, true);
            this.input_Description.setValue(data.description, true);
            this.input_Note.setValue(data.note, true);

            this.input_SeatingCapacity.setValue(data.seating_capacity, true);

            this.checkbox_Default.setValue(data.is_default, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            //this.input_Room._loadListValues();

            this.input_Code.setValue("", true);
            this.input_Description.setValue("", true);
            this.input_Note.setValue("", true);

            this.input_SeatingCapacity.setValue(null, true);

            this.checkbox_Default.setValue(false, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }
        if (this.filesEnabled) {
            this.filelist.startup();
            if (data) {
                this.formData.existingFiles = data.existingFiles;
                this.formData.newFiles = data.newFiles;
                this.formData.deletedFiles = data.deletedFiles;
            }
            this.filelist.setup(this.formData.existingFiles, this.formData.deletedFiles, this.formData.newFiles, data?.ID);
            this.filelist.on("change", lang.hitch(this, this.serializeFormData, null))

            data?.existingFiles.length ? this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        }

        this.serializeFormData(evRoomId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(evRoomId?: string): void {

        this.formData.code = this.input_Code.getValue();
        this.formData.description = this.input_Description.getValue();
        this.formData.note = this.input_Note.getValue();

        this.formData.seating_capacity = this.input_SeatingCapacity.getValue();

        this.formData.is_default = this.checkbox_Default.getValue();
        if (this.filesEnabled) {
            this.formData.newFiles = this.filelist.getData().new;

            if (!this.formData.deletedFiles) this.formData.deletedFiles = [];
            for (let fileId of this.filelist.getData().deleted) {
                if (this.formData.deletedFiles.indexOf(fileId) == -1) this.formData.deletedFiles.push(fileId);
            }
        }
        //evRoomId ? this.formData.ev_room_id = evRoomId : this.formData.ev_room_id = this.input_Room.getValue();
        if (evRoomId != null && typeof evRoomId == "string") {
            this.formData.ev_room_id = evRoomId;
        }
        this.emit("SerializeData");

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeAudienceSeatingLayoutsInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        /*if (!this.formData.ev_room_id) {

            this.indicateErrorOnInput(this.input_Room.outerInput);
            b = false;
        }*/

        return b;
    }

    hideSaveButton(hide: boolean): void {

        this.UiModder.domClass.toggle(this.saveButton, "w3-hide", hide);
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.AudienceSeatingLayouts;

        this.input_Code.setMaxLength(10);
        this.input_Description.setMaxLength(255);
        this.input_Note.setMaxLength(2000);
        this.input_Note.setValidationEnabled(false);

        if (this.hasFeature("MainCatalog/AudienceSeatingLayoutsFiles")) {
            this.filesEnabled = true;
            this.UiModder.domClass.remove(this.filesSection, "w3-hide w3-disabled");
        }
        //this.UiModder.domAttr.set(this.input_Room.outerInput, "placeholder", this.translations["MainCatalogsEditor_Placeholder_Room"]);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(AudienceSeatingLayoutsEditor.prototype, {
  input_Code: () => (new Edit()),
  input_Description: () => (new Edit()),
  input_Note: () => (new Edit()),
  input_SeatingCapacity: () => (new NumberInput()),
  checkbox_Default: () => (new CheckBox()),
});
export default mdsWidget(AudienceSeatingLayoutsEditor);